"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gazzo-veronese": {
    "99dbb754": [{
      "hkey": "1b65a1a4",
      "slug": "correzzo",
      "name": "Correzzo",
      "primary": true,
      "skipSearch": false
    }],
    "corezzo": [{
      "hkey": "1b65a1a4",
      "slug": "correzzo",
      "name": "Correzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2eec773c": [{
      "hkey": "dc3410a9",
      "slug": "pradelle",
      "name": "Pradelle",
      "primary": true,
      "skipSearch": false
    }],
    "pradele": [{
      "hkey": "dc3410a9",
      "slug": "pradelle",
      "name": "Pradelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;